import axios from "axios";

const API_URL =
  import.meta.env.VITE_CRM_API_URL || "https://dashboard.lono.co.in/api/staff";

// Helper function to get headers with token
const getAuthHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token =
    localStorage.getItem("adminToken") || localStorage.getItem("staffToken"); // Adjust token key if necessary
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

// Allowed roles for validation
const allowedRoles = ["admin", "manager", "agent", "support", "supervisor"];

export const staffAPI = {
  // Create a new staff member
  createStaff: async (staffData) => {
    // staffData now includes profilePicture as a Base64 string
    try {
      const response = await axios.post(`${API_URL}/create`, staffData, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all staff members
  getAllStaff: async (filters = {}) => {
    try {
      const response = await axios.get(`${API_URL}/all`, {
        params: filters,
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  getByRole: async (role) => {
    try {
      const response = await axios.get(`${API_URL}/role/${role}`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get staff member by ID
  getStaffById: async ({ staffId }) => {
    try {
      const response = await axios.get(`${API_URL}/${staffId}`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update staff member
  updateStaff: async (staffId, updateData) => {
    // updateData might include profilePicture as a Base64 string
    try {
      console.log("StaffId being sent to API:", staffId);
      const response = await axios.put(`${API_URL}/${staffId}`, updateData, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete staff member
  deleteStaff: async (staffId) => {
    try {
      const response = await axios.delete(`${API_URL}/${staffId}`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get staff members by role
  getStaffByRole: async (role) => {
    try {
      if (!allowedRoles.includes(role)) {
        throw new Error(`Invalid role: ${role}`);
      }
      const response = await axios.get(`${API_URL}/role/${role}`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  // Get staff with Loans
  getStaffWithLoans: async () => {
    try {
      const response = await axios.get(`${API_URL}/staffwithloans`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Assign an application (loan) to a staff member
  assignApplicationToStaff: async (staffId, applicationId) => {
    try {
      const response = await axios.patch(
        `${API_URL}/${staffId}/assign-application/${applicationId}`,
        {},
        {
          // Added empty object for PATCH data
          headers: getAuthHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get staff members created by a specific user
  getStaffCreatedBy: async (userId) => {
    try {
      const response = await axios.get(`${API_URL}/created-by/${userId}`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};
